import { createStore } from 'redux';
import { Reducers } from './reducers/states'

export const Store = createStore(Reducers);